import { optionsAttendeeStatus } from "@/pages/taskpane/features/resources/services/useGetAttendeeStatus";
import { useQueryClient } from "@tanstack/react-query";
import {
  AttendeeCalendarEvent,
  AttendeeInfo,
  IGetAttendeeStatusRequest,
} from "../../resources/services/types/attendeeEntity";
import { useAttendeesStore } from "@/pages/taskpane/shared/stores";

export const useTimelineAttendee = () => {
  const queryClient = useQueryClient();
  const { updateMeetingsAttendee } = useAttendeesStore();

  const getAttendeeStatusByDate = async (attendee: AttendeeInfo, currentDate: string, timeZone: string) => {
    const isExist = attendee.meetings.some((m) => m.id.includes(`uuid-${currentDate}`));
    if (isExist) {
      return;
    }
    const request: IGetAttendeeStatusRequest = {
      userEmails: [attendee.email],
      interval: 30,
      timeZoneStandardName: timeZone || "",
      timeZoneOccurrence: timeZone || "",
      isRecurring: false,
      occurrences: [
        {
          startDate: `${currentDate}T00:00:00`,
          endDate: `${currentDate}T23:59:59`,
        },
      ],
    };
    const attendeeStatusResponse = await queryClient.fetchQuery(optionsAttendeeStatus(request));
    if (attendeeStatusResponse[attendee.email] && attendeeStatusResponse[attendee.email].calendarEvents) {
      const meetings =
        attendeeStatusResponse[attendee.email].calendarEvents?.map(
          (event, index) => new AttendeeCalendarEvent(event, currentDate, index)
        ) ?? [];
      updateMeetingsAttendee(attendee, meetings);
    }
  };
  return {
    getAttendeeStatusByDate,
  };
};
